import React from 'react';

export const navigationItemStyle = {
  color: '#234C7D',
  height: '32px',
  paddingLeft: '5px',
  paddingRight: '5px',
  paddingTop: '0px',
  paddingBottom: '0px',
  '&:hover': {
    marginLeft: '5px'
  }
} as React.CSSProperties;

export const navigationItemActiveStyle = {
  background: '#fff'
} as React.CSSProperties;
